import React from 'react';
import Link from 'components/links/Link';
import Button from 'components/buttons/Button';

const features = [
    {
        number: '1.',
        text: 'Vsestranski, zmogljiv in preprost za uporabo'
    },
    {
        number: '2.',
        text: 'Profesionalna kakovost slike in videa'
    },
    {
        number: '3.',
        text: 'Optična stabilizacija in ostrina'
    },
    {
        number: '4.',
        text: 'Čist zvok z vgrajenim mikrofonom'
    },
    {
        number: '5.',
        text: 'Povezljivost s pametnim telefonom'
    }
];

const Feature = ({ feature }) => {
    return (
        <div className={'flex relative max-w-[220px] pl-6 items-center z-10'}>
            <div className="text-brand text-opacity-20 absolute left-0 text-8xl font-bold font-serif">
                {feature.number}
            </div>
            <p className={'relative z-10 text-lg leading-tight pt-1'}>{feature.text}</p>
        </div>
    );
};
const NikonZ30 = () => {
    return (
        <div className={'container relative'}>
            <div className="intro relative z-10">
                <h2 className={'lg:text-center text-brand'}>Ustvarjaj kot še nikoli</h2>
                <h3 className={'lg:text-center text-xl uppercase'}>NIKON Z 30</h3>
            </div>

            <div className="relative max-w-4xl mx-auto lg:pr-24">
                <img src="/images/foto-izbor/nikon-z30.jpg" alt="Nikon Z 30" className={'lg:w-[90%] -mt-6'} />
                <div className="hidden lg:block absolute top-8 left-0">
                    <Feature feature={features[0]} />
                </div>
                <div className="hidden lg:block absolute top-36 left-0">
                    <Feature feature={features[1]} />
                </div>
                <div className="hidden lg:block absolute top-16 right-0">
                    <Feature feature={features[2]} />
                </div>
                <div className="hidden lg:block absolute top-52 right-0">
                    <Feature feature={features[3]} />
                </div>
                <div className="hidden lg:block absolute top-[350px] right-12">
                    <Feature feature={features[4]} />
                </div>
            </div>
            <div className="features lg:hidden flex flex-wrap gap-12">
                {features.map((feature, index) => (
                    <Feature feature={feature} key={index} />
                ))}
            </div>
            <div className="ctas max-w-xl mx-auto mt-12 lg:-mt-24 z-10 relative flex flex-wrap gap-4 justify-between items-end">
                <div className="partners">
                    <p>
                        <small>PARTNERJA</small>
                    </p>
                    <div className="flex items-center gap-3">
                        <Link to="https://bigbang.si" target="_blank">
                            <img
                                src="/images/foto-izbor/bigbang-logo.svg"
                                alt="Big bang Slovenija"
                                className="inline-block h-8"
                            />
                        </Link>

                        <img src="/images/foto-izbor/logo-nikon.svg" alt="Nikon" className="inline-block h-8" />
                    </div>
                </div>

                <div className="link">
                    <Button
                        color={'secondary'}
                        link="https://www.bigbang.si/akcije-popusti/foto-kamere-droni/prihrani-z-nikon-10184/"
                        target={'_blank'}
                    >
                        Prihrani takoj
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default NikonZ30;
